import * as types from "../../types/travel";
import axios from "axios";

const token = localStorage.getItem("token:key");
const URL = `/api/v1/travel`;

//////////////////////////////////////////////
/////////// Accommodation Booking ////////////
//////////////////////////////////////////////
export const createACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.CREATE_ACR_REQUEST,
        });
        const { data } = await axios.post(`${URL}/accommodation`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.CREATE_ACR,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.CREATE_ACR_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const submitACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.SUBMIT_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/submit/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.SUBMIT_ACR,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.SUBMIT_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const updateACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.UPDATE_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.UPDATE_ACR,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.UPDATE_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const deleteACR = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.DELETE_ACR_REQUEST,
        });
        await axios.delete(`${URL}/accommodation/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.DELETE_ACR,
            payload: id,
        });
    } catch (error) {
        dispatch({
            type: types.DELETE_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getACRs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_ACRS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/accommodation`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_ACRS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_ACRS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getACR = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_ACR_REQUEST,
        });
        const { data } = await axios.get(`${URL}/accommodation/${id}/single`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_ACR,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_ACR_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const approveACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.APPROVE_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/approve/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.APPROVE_ACR,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.APPROVE_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const rejectACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.REJECT_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/reject/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.REJECT_ACR,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.REJECT_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const acceptACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.ACCEPT_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/accept/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.ACCEPT_ACR,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.ACCEPT_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const declineACR = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.DECLINE_ACR_REQUEST,
        });
        const { data } = await axios.put(`${URL}/accommodation/decline/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        
        dispatch({
            type: types.DECLINE_ACR,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.DECLINE_ACR_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};
